import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import { ExportToCsv } from 'export-to-csv';
import { ElementSchemaRegistry } from '@angular/compiler';
import { DatePipe } from '@angular/common'
import { ExcelService } from 'src/app/excel.service';
type AOA = any[][];

@Component({
  selector: 'app-teamheadoverallptpreport',
  templateUrl: './teamheadoverallptpreport.component.html',
  styleUrls: ['./teamheadoverallptpreport.component.css']
})
export class TeamheadoverallptpreportComponent implements OnInit {


  record_count: number = 0;
  count_down = 0;
  final_datas = [];

  final_datas1 =  [];
  origianl_bank_list = [];
  original_portfolio_list = [];
  loader_status = false;
  detailed_export_status = false;

  portfolio_list = [];



  constructor(    private excelService: ExcelService,public datepipe: DatePipe,private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,) { }

  show_loader = true;
  FollowUpList : any;
  user_list: any = [];
  agent_search : any;
  ptp_end_date : any;
  ptp_start_date : any;

  ngOnInit(): void {
    this.portfolio_list_get();
    this.bank_list_get();

    let login_Details = this.getFromLocal("login_Details");
    // this.portfolio_list = login_Details.selected_portfolio_list;


    this._api.user_details_list().subscribe(
      (response: any) => {
        this.user_list = response.Data;
      }
    );

    let a = {
      client_id: this.getFromLocal('Client_ID'),
    }
    console.log("a",a);

    this._api.portfolio_type_list(a).subscribe(data => {
      if (data['Code'] == 200) {
        this.portfolio_list = data['Data']
        console.log("this.portfolio_list",this.portfolio_list);

      } else {
        this.portfolio_list = [];
      }
    });
  }






  getFromLocal(key): any {
    return this.storage.get(key);
  }
buildReportFilter() {
  let end_date = new Date(this.ptp_end_date + 'T01:00:00.000Z');
  end_date.setDate(end_date.getDate() + 1);
  return {
    start_date: new Date(this.ptp_start_date + 'T01:00:00.000Z'),
    end_date: new Date(end_date),
    portfolio_id: this.agent_search,
  };
}

datesearch() {
  let final_data = [];
  this.final_datas1 = [];
  this.count_down = 0;
  let login_Details = this.getFromLocal("login_Details");
  var dataFormat = this.buildReportFilter();
  this._api.over_all_followup_portfolio_report_findcount(dataFormat).subscribe(data => {
    if (data['Code'] == 200) {
      this.FollowUpList = data['Data'];

      if (this.FollowUpList.length == 0) {
        alert("No record Found");
      }

      this.FollowUpList.forEach(element => {
        element.no_of_count = 1;
        let dates = element.createdAt.split('T');
        element.entry_date = dates[0];
        if (element.customer.customer_details) {
          var tempDetail = element.customer.customer_details ? element.customer.customer_details[0] : [];
          let name = tempDetail ? JSON.parse(tempDetail) : null;
          element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name : '';
          element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : '';
        }
      });
      console.log(this.FollowUpList,"this.FollowUpList");

      for (let a = 0; a < this.FollowUpList.length; a++) {
        if (a == 0) {
          final_data.push(this.FollowUpList[a]);
        } else {
          let check_status = 0;
          // let temp_count = final_data.length;
          // for (let b = 0; b < temp_count; b++) {
          //   if (a < this.FollowUpList.length) {
          //     if (this.FollowUpList[a].finterstal_id == final_data[b].finterstal_id) {
          //       check_status = 1;
          //       final_data[b].no_of_count = final_data[b].no_of_count + 1;
          //     }
          //     if (b == temp_count - 1) {
                if (check_status == 0) {
                  final_data.push(this.FollowUpList[a]);
                }
            //   }
            // }
          // }
        }
        if (a == this.FollowUpList.length - 1) {
          this.final_datas = final_data;
          this.record_count = final_data.length;
          this.loader_status = true;
          this.final_datas1 = [];
          this.call_fetch_data(0); // Start fetching data from index 0
        }
      }
    } else {
      this.FollowUpList = [];
    }
    console.log(" this.final_datas", this.final_datas);

  });
}

call_fetch_data(index: number) {
  const batchSize = 10; // Number of records to fetch in each batch
  const endIndex = Math.min(index + batchSize, this.final_datas.length); // Calculate the end index for the batch

  if (index < this.final_datas.length) {
    for (let i = index; i < endIndex; i++) {
      let a = {
        finterstal_id: this.final_datas[i].finterstal_id
      };

      this._api.fetch_data_search(a).subscribe((data: any) => {
        var obj = JSON.parse(data.Data.customer.customer_details);
        obj = obj[0];

const Tos = obj && obj[' total_out_standing '] ? obj[' total_out_standing '] :obj.total_out_standing;
// console.log("obj",Tos);
        let porfolio_name = '';
        this.original_portfolio_list.forEach(element => {
          if (element._id == this.final_datas[i].portfolio_id) {
            porfolio_name = element.portfolio_type;
          }
        });

        let datas = {
          finterstal_id: this.final_datas[i].finterstal_id,
          Bank: this.final_datas[i].bank_id.bank_name,
          Portfolio: porfolio_name,
          Product: data.Data.customer.product_name,
          CIF: data.Data.customer.cif,
          CID: '',
          Acc_Number: data.Data.customer.acc_no,
          Name: obj.Customer_Name,
          TOS: Tos,
          POS: obj.PRINCIPLE_AMT,
          CL: obj.creditlimit,
          Current_Date: this.final_datas[i].entry_date,
          Last_Status_of_that_day: this.final_datas[i].mstatus,
          Last_SubStatus_of_that_day: this.final_datas[i].substatus,
          Follow_Up_date: this.final_datas[i].fdate,
          This_Day_remark_only: this.final_datas[i].remarks,
          Agent: this.final_datas[i].createdby.name,
          No_of_attemptes_for_the_day: this.final_datas[i].no_of_count
        };

        this.final_datas1.push(datas);
      });
    }

    // Fetch next batch of data with a small delay to avoid overloading the system
    setTimeout(() => {
      this.call_fetch_data(index + batchSize);
    },300);
  } else {
    this.loader_status = false;
  }
}






  clear(){

  }


  exportPTPreport(){

  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.final_datas1,'Follow UP Report');
  }

  exportDetailedExcel(): void {
    if (!this.ptp_start_date || !this.ptp_end_date) {
      alert('Select start date and end date');
      return;
    }
    this.detailed_export_status = true;
    this._api.over_all_followup_accountwise_detailed(this.buildReportFilter()).subscribe(
      (data: any) => {
        this.detailed_export_status = false;
        if (data['Code'] != 200 || !data['Data'] || data['Data'].length == 0) {
          alert('No record Found');
          return;
        }
        const sheet = this.buildAccountWiseRows(data['Data']);
        this.excelService.exportAsExcelFileWithHeaders(sheet.records, 'Account Wise Feedback Report', sheet.headers);
      },
      () => {
        this.detailed_export_status = false;
        alert('Unable to export detailed excel');
      }
    );
  }

  buildAccountWiseRows(accounts: any[]) {
    const baseHeaders = [
      'Officer', 'fint_id', 'Bank', 'Allocated Date', 'CIF',
      'Acc_Number', 'Name', 'TOS',
      'Total_Feedback_Entries', 'First_Feedback_Date', 'Last_Feedback_Date', 'Feedback_History'
    ];
    let maxFeedbacks = 0;
    accounts.forEach((account) => {
      const count = (account.feedbacks || []).length;
      if (count > maxFeedbacks) {
        maxFeedbacks = count;
      }
    });

    const headers = baseHeaders.slice();
    for (let i = 1; i <= maxFeedbacks; i++) {
      headers.push(
        'Feedback_' + i + '_Date',
        'Feedback_' + i + '_Status',
        'Feedback_' + i + '_SubStatus',
        'Feedback_' + i + '_Follow_Up_Date',
        'Feedback_' + i + '_PTP_Amount',
        'Feedback_' + i + '_Remark'
      );
    }

    const records = accounts.map((account) => {
      const feedbacks = account.feedbacks || [];
      const history = feedbacks.map((feedback) => {
        const status = [feedback.status, feedback.substatus].filter((value) => !!value).join(' / ');
        const followUp = feedback.follow_up_date ? ' Follow-up: ' + feedback.follow_up_date : '';
        const ptpAmount = feedback.ptp_amount ? ' PTP Amount: ' + feedback.ptp_amount : '';
        const remark = feedback.remark ? ' — ' + feedback.remark : '';
        return (feedback.date || '') + (status ? ' [' + status + ']' : '') + followUp + ptpAmount + remark;
      }).join(' || ');

      const row: any = {
        Officer: account.officer || '',
        fint_id: account.finterstal_id || '',
        Bank: account.bank || '',
        'Allocated Date': account.allocated_date || '',
        CIF: account.cif || '',
        Acc_Number: account.acc_number || '',
        Name: account.name || '',
        TOS: account.tos || '',
        Total_Feedback_Entries: feedbacks.length,
        First_Feedback_Date: feedbacks.length ? feedbacks[0].date : '',
        Last_Feedback_Date: feedbacks.length ? feedbacks[feedbacks.length - 1].date : '',
        Feedback_History: history.length > 32000 ? history.slice(0, 32000) : history
      };

      for (let i = 0; i < maxFeedbacks; i++) {
        const feedback = feedbacks[i] || {};
        const index = i + 1;
        row['Feedback_' + index + '_Date'] = feedback.date || '';
        row['Feedback_' + index + '_Status'] = feedback.status || '';
        row['Feedback_' + index + '_SubStatus'] = feedback.substatus || '';
        row['Feedback_' + index + '_Follow_Up_Date'] = feedback.follow_up_date || '';
        row['Feedback_' + index + '_PTP_Amount'] = feedback.ptp_amount || '';
        row['Feedback_' + index + '_Remark'] = feedback.remark || '';
      }
      return row;
    });

    return { records, headers };
  }


  portfolio_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
      }
    );
  }


bank_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.origianl_bank_list = response.Data;
      }
    );
  }

}

